var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_393_2248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 13.668C4 14.2422 4.48047 14.7109 5.04297 14.7109H12.625V22.293C12.625 22.8555 13.0938 23.3359 13.668 23.3359C14.2422 23.3359 14.7227 22.8555 14.7227 22.293V14.7109H22.293C22.8555 14.7109 23.3359 14.2422 23.3359 13.668C23.3359 13.0938 22.8555 12.6133 22.293 12.6133H14.7227V5.04297C14.7227 4.48047 14.2422 4 13.668 4C13.0938 4 12.625 4.48047 12.625 5.04297V12.6133H5.04297C4.48047 12.6133 4 13.0938 4 13.668Z",
    fill: "currentColor",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_393_2248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3359,
    height: 19.3477,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.9379b13ae7f24684eeca0d64c207249a.svg";
export { ForwardRef as ReactComponent };